import getters from './getters';
import actions from './actions';
import mutations from './mutations';

const state = () => ({
  conversations: [],
  tmpMessages: [],
  activeConversationId: null
});

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
};
